import order from '../assets/release-2026-10-27/nicht-erreicht-01-status-menue.png'
import menu from '../assets/release-2026-10-27/nicht-erreicht-02-bestaetigen.png'
import attempt from '../assets/release-2026-10-27/nicht-erreicht-03-versuch-erfassen.png'
import threeAttempts from '../assets/release-2026-10-27/nicht-erreicht-04-drei-versuche.png'
import { makeBox, type GuideStepContent } from './guideStep'

/** Desktop screenshots, 1920×1080. */
const box = makeBox(1920, 1080)

export const NICHT_ERREICHT_INTRO =
  'Erreichen Sie den Mieter nicht, setzen Sie den Auftrag auf „Nicht erreicht“ und erfassen jeden Kontaktversuch. Nach dem 3. Versuch können Sie den Auftrag auf „Gelöscht“ setzen.'

export const NICHT_ERREICHT_STEPS: GuideStepContent[] = [
  {
    title: 'Status öffnen',
    text: 'Öffnen Sie den Auftrag. Neben dem Titel steht der Status, zum Beispiel „Nicht geplant“. Klicken Sie darauf.',
    image: order,
    imageAlt: 'Auftrag mit dem Status „Nicht geplant“ neben dem Titel',
    focus: [box(764, 200, 1016, 244)],
    wide: true,
  },
  {
    title: '„Nicht erreicht“ wählen',
    text: 'Wählen Sie im Menü „Nicht erreicht“ und bestätigen Sie mit „Status ändern“.',
    image: menu,
    imageAlt: 'Geöffnetes Status-Menü mit dem Eintrag „Nicht erreicht“',
    focus: [box(770, 380, 1048, 420)],
    wide: true,
  },
  {
    title: 'Kontaktversuch erfassen',
    text: 'Unter dem Titel erscheint die Karte „Kontaktversuche“ mit Zähler und Kommentarfeld. Klicken Sie auf „Weiteren Versuch erfassen“ und tragen Sie ein, was versucht wurde. Datum und Uhrzeit stehen auf jetzt, Sie können sie ändern. Speichern Sie mit „Versuch erfassen“.',
    note: {
      title: 'Kommentar',
      text: 'Der Kommentar ist nur für das Büro sichtbar, nicht für den Mieter.',
    },
    image: attempt,
    imageAlt: 'Karte „Kontaktversuche“ mit geöffnetem Formular',
    focus: [
      box(392, 490, 1022, 535),
      box(393, 573, 1021, 618),
      box(881, 628, 1021, 666),
      box(1052, 396, 1854, 526),
    ],
    wide: true,
  },
  {
    title: 'Nach dem 3. Versuch',
    text: 'Sind drei Versuche erfasst, erscheint der Hinweis „3. Versuch erfasst.“ mit dem Knopf „Auf Gelöscht setzen“. Ob der Auftrag gelöscht wird, entscheidet das Büro.',
    note: {
      title: 'Erinnerung',
      text: 'Steht ein Auftrag 3 Wochen auf „Nicht erreicht“, bekommt das Büro eine Erinnerung.',
    },
    image: threeAttempts,
    imageAlt: 'Karte mit 3 von 3 Versuchen und dem Knopf „Auf Gelöscht setzen“',
    focus: [box(354, 368, 560, 430), box(394, 672, 553, 710)],
    wide: true,
  },
]
